import {
  LicenseCoarseLevels,
  LicenseFineLevels,
  UserAccessBadge,
} from '../hooks/useAccessBadge';

export const REPORTS_PAYWALL_CUTOFF_MS = 1778137200000;

export const isPostCutoffReport = (
  lastPlayedAt: number | null | undefined,
): boolean =>
  typeof lastPlayedAt === 'number' && lastPlayedAt > REPORTS_PAYWALL_CUTOFF_MS;

// US teachers must be on the School Plan (Enterprise, or Premium with the full
// fine-level) to view post-cutoff reports. Outside the US, any Premium tier
// (trial or full) or Enterprise unlocks them.
export const userCanViewPaywalledReport = (
  accessBadge: UserAccessBadge | undefined,
): boolean => {
  if (!accessBadge?.license) return false;
  const { coarseLevel, fineLevel } = accessBadge.license;
  if (coarseLevel === LicenseCoarseLevels.enterprise) return true;
  if (coarseLevel !== LicenseCoarseLevels.premium) return false;
  const isUS = accessBadge.organization?.country === 'US';
  return isUS ? fineLevel === LicenseFineLevels.full : true;
};

export const isReportPaywalled = (
  accessBadge: UserAccessBadge | undefined,
  lastPlayedAt: number | null | undefined,
): boolean =>
  isPostCutoffReport(lastPlayedAt) && !userCanViewPaywalledReport(accessBadge);
